import { render, staticRenderFns } from "./ListSwitcher.vue?vue&type=template&id=0a670d64&scoped=true"
import script from "./ListSwitcher.vue?vue&type=script&lang=js"
export * from "./ListSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ListSwitcher.vue?vue&type=style&index=0&id=0a670d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a670d64",
  null
  
)

export default component.exports